import {
  IApiAccountType,
  IApiSelfTradingAccountTypeViewModel,
  IApiTradingPlatformType,
  IApiUserTradingAccountType,
} from '@api/interfaces/data-contracts';
import { TradingAccountTypes } from '@components-member/TradingAccounts/AccountCreate/components/AccountCreateTabs/AccountCreateTabs';
import {
  AccountCreateToggleButtonType,
  investorAccountButton,
  masterAccountButton,
  selfTAccountButton,
} from '@components-member/TradingAccounts/AccountCreate/components/AccountCreateToggleButtons/constants';
import type { IAccountCreationQueryParams } from '@components-member/TradingAccounts/hooks/useAccountCreationQueryParams';
import { TRADING_ACCOUNT_FORM_TYPE } from 'global.enums';

export const getAvailableTypeTabs = (
  tradingAccounts: TradingAccountTypes,
  platform?: IAccountCreationQueryParams['platformType'],
  hasContestId?: string | null,
) => {
  const availableAccountTab = new Set<IApiAccountType>();

  switch (platform) {
    case IApiTradingPlatformType.Meta4:
    case IApiTradingPlatformType.Gmi:
    case IApiTradingPlatformType.Meta5:
      getSelfTradeAccountType(tradingAccounts[TRADING_ACCOUNT_FORM_TYPE.SELF], availableAccountTab, platform);
      getSocialTradingAccountTypeByLength(tradingAccounts[TRADING_ACCOUNT_FORM_TYPE.MASTER], availableAccountTab);
      getSocialTradingAccountTypeByLength(tradingAccounts[TRADING_ACCOUNT_FORM_TYPE.INVESTOR], availableAccountTab);
      break;
    case 'None':
    default:
      availableAccountTab.add(IApiAccountType.Real);
      if (!hasContestId) {
        availableAccountTab.add(IApiAccountType.Demo);
      }
  }

  return availableAccountTab;
};

export const getAvailableAccountTypeButtons = (
  accountTypes: TradingAccountTypes,
  platform?: IAccountCreationQueryParams['platformType'],
) => {
  const availableAccountButtonTypes = new Set<AccountCreateToggleButtonType>([]);

  switch (platform) {
    case IApiTradingPlatformType.Meta4:
    case IApiTradingPlatformType.Gmi:
    case IApiTradingPlatformType.Meta5:
      {
        if (accountTypes[TRADING_ACCOUNT_FORM_TYPE.SELF].some((acc) => acc.accountType !== 'Demo')) {
          availableAccountButtonTypes.add(selfTAccountButton);
        }

        if (accountTypes[TRADING_ACCOUNT_FORM_TYPE.INVESTOR].length) {
          availableAccountButtonTypes.add(investorAccountButton);
        }

        if (accountTypes[TRADING_ACCOUNT_FORM_TYPE.MASTER].length) {
          availableAccountButtonTypes.add(masterAccountButton);
        }
      }
      break;
    default:
      availableAccountButtonTypes.add(selfTAccountButton);
      availableAccountButtonTypes.add(investorAccountButton);
      availableAccountButtonTypes.add(masterAccountButton);
  }

  return availableAccountButtonTypes;
};

const getSocialTradingAccountTypeByLength = (
  accounts: IApiUserTradingAccountType[],
  availableAccountTab: Set<IApiAccountType>,
) => {
  if (accounts.length) {
    return availableAccountTab.add(IApiAccountType.Real);
  }
};

const getSelfTradeAccountType = (
  accounts: IApiSelfTradingAccountTypeViewModel[],
  availableAccountTab: Set<IApiAccountType>,
  platform?: IAccountCreationQueryParams['platformType'],
) => {
  accounts.forEach((i) => {
    if (i.tradingPlatformType === platform) {
      availableAccountTab.add(i.accountType);
    }
  });
};
